import { NgModule } from '@angular/core'
import { RouterModule, type Routes } from '@angular/router'
import { AuthGuard } from '@core/auth/auth.guard'

const pageLogin = async (): Promise<any> => (await import('@page/page-login/page-login.module')).PageLoginModule

const pageAgents = async (): Promise<any> => (await import('@page/page-agents/page-agents.module')).PageAgentsModule
const pageResellers = async (): Promise<any> => (await import('@page/page-resellers/page-resellers.module')).PageResellersModule
const pageActivities = async (): Promise<any> => (await import('@page/page-activities/page-activities.module')).PageActivitiesModule
const pageAlerts = async (): Promise<any> => (await import('@page/page-alerts/page-alerts.module')).PageAlertsModule
// const pageLoads = async (): Promise<any> => (await import('@page/page-loads/page-loads.module')).PageLoadsModule
const pageLogs = async (): Promise<any> => (await import('@page/page-logs/page-logs.module')).PageLogsModule
const pageOffer = async (): Promise<any> => (await import('@page/page-offer/page-offer.module')).PageOfferModule
const pageOverview = async (): Promise<any> => (await import('@page/page-overview/page-overview.module')).PageOverviewModule
const pageSupervision = async (): Promise<any> => (await import('@page/page-supervision/page-supervision.module')).PageSupervisionModule
const pageGestion = async (): Promise<any> => (await import('@page/page-gestion/page-gestion.module')).PageGestionModule
const pagePlanning = async (): Promise<any> => (await import('@page/page-planning/page-planning.module')).PagePlanningModule
const pageMobility = async (): Promise<any> => (await import('@page/page-mobility/page-mobility.module')).PageMobilityModule
const pageUsager = async (): Promise<any> => (await import('@page/page-usager/page-usager.module')).PageUsagerModule
const pageSocial = async (): Promise<any> => (await import('@page/page-social/page-social.module')).PageSocialModule
const pageConformite = async (): Promise<any> => (await import('@page/page-conformite/page-conformite.module')).PageConformiteModule
const pageResilience = async (): Promise<any> => (await import('@page/page-resilience/page-resilience.module')).PageResilienceModule
const pageSurete = async (): Promise<any> => (await import('@page/page-surete/page-surete.module')).PageSureteModule
const pageFinancement = async (): Promise<any> => (await import('@page/page-financement/page-financement.module')).PageFinancementModule
const pageParameters = async (): Promise<any> => (await import('@page/page-parameters/page-parameters.module')).PageParametersModule
const pageStations = async (): Promise<any> => (await import('@page/page-stations/page-stations.module')).PageStationsModule
const pageTerminalsBus = async (): Promise<any> => (await import('@page/page-terminals-bus/page-terminals-bus.module')).PageTerminalsBusModule
const pageTerminalsNav = async (): Promise<any> => (await import('@page/page-terminals-nav/page-terminals-nav.module')).PageTerminalsNavModule
const pageValidations = async (): Promise<any> => (await import('@page/page-validations/page-validations.module')).PageValidationsModule
const pageNetworkCoverage = async (): Promise<any> => (await import('@page/page-network-coverage/page-network-coverage.module')).PageNetworkCoverageModule
// const pageAccounts = async (): Promise<any> => (await import('@page/page-accounts/page-accounts.module')).PageAccountsModule

const pageUsers = async (): Promise<any> => (await import('@page/page-users/page-users.module')).PageUsersModule
const pageSettings = async (): Promise<any> => (await import('@page/page-settings/page-settings.module')).PageSettingsModule

const page404 = async (): Promise<any> => (await import('@page/page-not-found/page-not-found.module')).PageNotFoundModule

const pageFines = async (): Promise<any> => (await import('@page/page-fines/page-fines.module')).PageFinesModule
const pageTopUp = async (): Promise<any> => (await import('@page/page-top-up/page-top-up.module')).PageTopUpModule
const pageLostFound = async (): Promise<any> => (await import('@page/page-lost-found/page-lost-found.module')).PageLostFoundModule
const pagePax = async (): Promise<any> => (await import('@page/page-pax/page-pax.module')).PagePaxModule

const routes: Routes = [
  { path: 'login', loadChildren: pageLogin },

  { path: 'activities', loadChildren: pageActivities, canActivate: [AuthGuard] },
  { path: 'agents', loadChildren: pageAgents, canActivate: [AuthGuard] },
  { path: 'alerts', loadChildren: pageAlerts, canActivate: [AuthGuard] },
  { path: 'fines', loadChildren: pageFines, canActivate: [AuthGuard] },
  // { path: 'loads', loadChildren: pageLoads, canActivate: [AuthGuard] },
  { path: 'logs', loadChildren: pageLogs, canActivate: [AuthGuard] },
  { path: 'lost-found', loadChildren: pageLostFound, canActivate: [AuthGuard] },
  { path: 'offer', loadChildren: pageOffer, canActivate: [AuthGuard] },
  { path: 'overview', loadChildren: pageOverview, canActivate: [AuthGuard] },
  { path: 'supervision', loadChildren: pageSupervision, canActivate: [AuthGuard] },
  { path: 'gestion', loadChildren: pageGestion, canActivate: [AuthGuard] },
  { path: 'planning', loadChildren: pagePlanning, canActivate: [AuthGuard] },
  { path: 'mobility', loadChildren: pageMobility, canActivate: [AuthGuard] },
  { path: 'usager', loadChildren: pageUsager, canActivate: [AuthGuard] },
  { path: 'social', loadChildren: pageSocial, canActivate: [AuthGuard] },
  { path: 'conformite', loadChildren: pageConformite, canActivate: [AuthGuard] },
  { path: 'resilience', loadChildren: pageResilience, canActivate: [AuthGuard] },
  { path: 'surete', loadChildren: pageSurete, canActivate: [AuthGuard] },
  { path: 'financement', loadChildren: pageFinancement, canActivate: [AuthGuard] },
  { path: 'parameters', loadChildren: pageParameters, canActivate: [AuthGuard] },
  { path: 'pax', loadChildren: pagePax, canActivate: [AuthGuard] },
  { path: 'stations', loadChildren: pageStations, canActivate: [AuthGuard] },
  { path: 'terminals-bus', loadChildren: pageTerminalsBus, canActivate: [AuthGuard] },
  { path: 'terminals-nav', loadChildren: pageTerminalsNav, canActivate: [AuthGuard] },
  { path: 'network-coverage', loadChildren: pageNetworkCoverage, canActivate: [AuthGuard] },
  { path: 'top-up', loadChildren: pageTopUp, canActivate: [AuthGuard] },
  { path: 'validations', loadChildren: pageValidations, canActivate: [AuthGuard] },

  { path: 'resellers', loadChildren: pageResellers, canActivate: [AuthGuard] },

  // { path: 'accounts', loadChildren: pageAccounts, canActivate: [AuthGuard] },

  { path: 'users', loadChildren: pageUsers, canActivate: [AuthGuard] },
  { path: 'settings', loadChildren: pageSettings, canActivate: [AuthGuard] },

  { path: '404', loadChildren: page404, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/overview', pathMatch: 'full' },
  { path: '**', redirectTo: '/404' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
